export default function getSwitchUserStorage() {
  return JSON.parse(sessionStorage.getItem("switchUser")) !== undefined
    ? JSON.parse(sessionStorage.getItem("switchUser"))
    : null;
}
